export const getURLPart = (part: number, url: string) => {
  const splitUrl = url.split('/');
  const foundPart = splitUrl[part] ? splitUrl[part].toLowerCase() : '';

  return foundPart;
};
